(() => {
  const initialize = () => {
    const header = document.querySelector('.rp-header');
    const search = header?.querySelector('[data-rp-search]');
    if (search && !search.dataset.ready) {
      search.dataset.ready = 'true';
      const trigger = search.querySelector('summary');
      const closeSearch = (restoreFocus = false) => {
        search.open = false;
        if (restoreFocus) trigger.focus({ preventScroll: true });
      };
      search.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(search.open));
        if (search.open) {
          header.querySelectorAll('.d2-desktop-nav details[open], .d2-delivery[open]').forEach(details => { details.open = false; });
          requestAnimationFrame(() => {
            if (search.open) search.querySelector('input[type="search"]')?.focus({ preventScroll: true });
          });
        }
      });
      search.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          closeSearch(true);
        }
      });
      search.addEventListener('focusout', event => {
        if (event.relatedTarget && !search.contains(event.relatedTarget)) closeSearch();
      });
      document.addEventListener('click', event => {
        if (search.open && !search.contains(event.target)) closeSearch();
      });
      window.addEventListener('blur', () => closeSearch());
      header.querySelectorAll('.d2-desktop-nav details').forEach(details => details.addEventListener('toggle', () => {
        if (details.open) closeSearch();
      }));
    }
    const delivery = header?.querySelector('.rp-header__delivery-tools');
    const menuDelivery = document.querySelector('[data-rp-menu-delivery]');
    if (header && delivery && menuDelivery && !header.dataset.servicesReady) {
      header.dataset.servicesReady = 'true';
      const home = delivery.parentElement;
      const mobileServices = matchMedia('(max-width: 1199px)');
      const placeServices = () => {
        const target = mobileServices.matches ? menuDelivery : home;
        if (delivery.parentElement !== target) target.append(delivery);
        menuDelivery.hidden = !mobileServices.matches;
        header.dataset.mobileServices = String(mobileServices.matches);
      };
      placeServices();
      mobileServices.addEventListener('change', placeServices);
    }
    const dialog = document.querySelector('[data-rp-menu]');
    if (dialog && !dialog.dataset.ready && typeof dialog.showModal === 'function') {
      dialog.dataset.ready = 'true';
      let opener;
      let marketHome;
      let market;
      let closingMarket = false;
      const menuMarket = dialog.querySelector('[data-rp-menu-market]');
      const closeMarket = () => {
        closingMarket = true;
        try {
          market?.querySelector('rdb-currency')?.close?.();
          market?.querySelectorAll('details[open]').forEach(details => { details.open = false; });
        } finally {
          closingMarket = false;
        }
      };
      const closeDelivery = () => {
        dialog.querySelector('rdb-emirate-picker')?.setOpen?.(false);
        dialog.querySelectorAll('.d2-delivery[open]').forEach(details => { details.open = false; });
      };
      // Keep one native localization form and one app-owned currency widget.
      const placeMarket = () => {
        market = document.querySelector('.rp-service-bar .rdb-market-controls');
        if (!market || !menuMarket) return;
        closeMarket();
        marketHome = document.createComment('premium-menu-market-home');
        market.before(marketHome);
        menuMarket.append(market);
      };
      const restoreMarket = () => {
        closeMarket();
        if (marketHome?.parentNode && market) marketHome.replaceWith(market);
        marketHome = null;
        market = null;
      };
      const triggers = [...document.querySelectorAll('[data-rp-menu-open]')];
      const close = () => dialog.close();
      triggers.forEach(trigger => trigger.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (dialog.open) return;
        opener = trigger;
        if (search) search.open = false;
        placeMarket();
        dialog.showModal();
        dialog.querySelector('.rp-menu__body').scrollTop = 0;
        triggers.forEach(button => button.setAttribute('aria-expanded', 'true'));
        dialog.querySelector('[data-rp-menu-close]')?.focus({ preventScroll: true });
      }));
      dialog.querySelector('[data-rp-menu-close]')?.addEventListener('click', close);
      dialog.addEventListener('close', () => {
        closeDelivery();
        restoreMarket();
        triggers.forEach(button => button.setAttribute('aria-expanded', 'false'));
        const target = opener?.getClientRects().length ? opener : document.querySelector('.rp-header .d2-desktop-nav summary, .rp-header .d2-logo');
        target?.focus({ preventScroll: true });
      });
      dialog.querySelector('.rp-menu__top')?.addEventListener('click', event => {
        if (!closingMarket && event.target.closest('.currency-switcher, .rdb-localization > summary')) closeDelivery();
        if (event.target.closest('.rdb-emirate__trigger, .d2-delivery > summary')) closeMarket();
        if (event.target.closest('.rdb-emirate__trigger')) {
          dialog.querySelectorAll('.d2-delivery[open]').forEach(details => { details.open = false; });
        }
      });
      dialog.addEventListener('focusin', event => {
        const details = dialog.querySelector('.d2-delivery[open]');
        if (details && !details.contains(event.target)) details.open = false;
      });
      dialog.addEventListener('click', event => {
        const details = dialog.querySelector('.d2-delivery[open]');
        if (details && !details.contains(event.target)) details.open = false;
      });
      dialog.addEventListener('keydown', event => {
        const deliveryDetails = event.target.closest('.d2-delivery[open]');
        if (event.key === 'Escape' && deliveryDetails) {
          event.preventDefault();
          event.stopPropagation();
          deliveryDetails.open = false;
          deliveryDetails.querySelector('summary')?.focus({ preventScroll: true });
        }
        if (event.key === 'Tab') {
          const controls = [...dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]')]
            .filter(control => control.tabIndex >= 0 && control.getClientRects().length > 0 && getComputedStyle(control).visibility !== 'hidden' && !control.closest('[inert]'));
          const first = controls[0];
          const last = controls.at(-1);
          const active = document.activeElement;
          if (event.shiftKey && (active === first || !controls.includes(active))) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && (active === last || !controls.includes(active))) {
            event.preventDefault();
            first?.focus();
          }
        }
      });
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }
      });
      const groups = [...dialog.querySelectorAll('.rp-menu__group')];
      groups.forEach(group => group.addEventListener('toggle', () => {
        if (group.open) groups.filter(other => other !== group).forEach(other => { other.open = false; });
      }));
      matchMedia('(min-width: 1200px)').addEventListener('change', event => {
        if (event.matches && dialog.open) close();
      });
      window.addEventListener('pagehide', () => { if (dialog.open) close(); });
    }
    document.querySelectorAll('.rdb-localization').forEach(language => {
      if (language.dataset.premiumReady) return;
      language.dataset.premiumReady = 'true';
      const summary = language.querySelector('summary');
      const panel = language.querySelector('.rdb-localization__panel');
      const options = [...language.querySelectorAll('.rdb-localization__option')];
      if (panel && !panel.id) panel.id = `${language.querySelector('form')?.id || 'PremiumLanguage'}-panel`;
      if (panel) summary.setAttribute('aria-controls', panel.id);
      language.addEventListener('keydown', event => {
        if (event.key === 'Escape' && language.open) {
          event.preventDefault();
          event.stopPropagation();
          language.open = false;
          summary.focus({ preventScroll: true });
        } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          language.open = true;
          const index = options.indexOf(document.activeElement);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1 : index < 0 ? (event.key === 'ArrowUp' ? options.length - 1 : 0) : (index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
          options[next]?.focus({ preventScroll: true });
        }
      });
    });
    const mobile = matchMedia('(max-width: 749px)');
    document.querySelectorAll('.rp-footer-disclosure').forEach(disclosure => {
      if (disclosure.dataset.ready) return;
      disclosure.dataset.ready = 'true';
      disclosure.open = !mobile.matches;
      mobile.addEventListener('change', () => { disclosure.open = !mobile.matches; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
